import { TextField, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect } from 'react';
import { OrderReviewContext } from '../../../OrderReviewContext';
import styles from './OtherTextField.styles';

const propTypes = {
  classes: PropTypes.object.isRequired,
  formDefinition: PropTypes.object.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  otherAnswer: PropTypes.object,
  saveAnswers: PropTypes.func.isRequired,
  updateFormHeaders: PropTypes.func.isRequired,
};

const OtherTextField = ({ classes, formDefinition, isReadOnly, otherAnswer, saveAnswers, updateFormHeaders }) => {
  const { dispatch: orderReviewDispatch } = useContext(OrderReviewContext);

  const debounceHandler = useCallback(
    debounce(value => {
      handleOnChange(value);
    }, 750),
    [],
  );

  const handleOnChange = async value => {
    const newAnswers = formDefinition.answers.map(answer => {
      if (answer.valueId === 12 || (answer.value && answer.value.substring(0, 5) === 'Other')) {
        answer.text = value.trim();
        return answer;
      }
      return answer;
    });
    updateFormHeaders(newAnswers);
    orderReviewDispatch({
      type: 'IS_EDITING',
      value: true,
    });
    saveAnswers(newAnswers);
  };

  return (
    <div className={classes.otherDetails}>
      <Typography
        variant="subtitle2"
        classes={{
          subtitle2: classes.otherSubtitle,
        }}
        className={formDefinition.answerType === 'Single Select' && classes.otherSubtitleSingleSelect}
        gutterBottom
      >
        Other Details
      </Typography>
      <TextField
        className={classes.textField}
        defaultValue={otherAnswer.text}
        onChange={event => debounceHandler(event.target.value)}
        margin="none"
        disabled={isReadOnly}
        multiline
      />
    </div>
  );
};

OtherTextField.propTypes = propTypes;
export default withStyles(styles)(OtherTextField);
